(() => {
  const WELCOME_SEL = 'slideshow-slide:has([class*="text_welcome_hello"])';
  const BOOT_MS = 550;
  const UPDATE_MS = 2800;
  const YEARS_MS = 4200;
  const LIVE_MS = 8200;
  const HOLD_MS = 16000;

  const GIFS = [
    { src: "https://web.archive.org/web/20091008000000im_/http://textfiles.com/underconstruction/AtAthensAtrium58407construction.gif", knock: true },
    { src: "https://web.archive.org/web/20091008040804im_/http://textfiles.com/underconstruction/Heartland7870construction_major.gif" },
    { src: "https://www.animatedimages.org/data/media/695/animated-under-construction-image-0047.gif" },
    { src: "https://www.animatedimages.org/data/media/695/animated-under-construction-image-0041.gif" },
    { src: "https://web.archive.org/web/20091008040700im_/http://textfiles.com/underconstruction/AtAthensCrete7872translationimagesunderconstruction_0045.gif" },
    { src: "https://web.archive.org/web/20091008030208im_/http://textfiles.com/underconstruction/Dunes8119construction.gif" },
    { src: "https://web.archive.org/web/20091008040611im_/http://textfiles.com/underconstruction/mamagnolia_acresunderconstruction.gif" },
  ];

  const CAT_PEEK =
    '<svg class="zc-welcome-era__peek-art" viewBox="0 0 28 24" xmlns="http://www.w3.org/2000/svg" shape-rendering="crispEdges" aria-hidden="true">' +
    '<rect x="4" y="10" width="16" height="10" fill="#f0c14a"/>' +
    '<rect x="6" y="4" width="12" height="10" fill="#f0c14a"/>' +
    '<rect x="6" y="1" width="4" height="5" fill="#f0c14a"/>' +
    '<rect x="14" y="1" width="4" height="5" fill="#f0c14a"/>' +
    '<rect x="7" y="2" width="2" height="3" fill="#f7d9a8"/>' +
    '<rect x="15" y="2" width="2" height="3" fill="#f7d9a8"/>' +
    '<rect x="8" y="7" width="2" height="2" fill="#111"/>' +
    '<rect x="14" y="7" width="2" height="2" fill="#111"/>' +
    '<rect x="11" y="9" width="2" height="1" fill="#7a3e14"/>' +
    '<rect x="20" y="14" width="7" height="3" fill="#f0c14a"/>' +
    "</svg>";

  const gifHtml = GIFS.map((gif, i) => {
    const extra = gif.knock ? " zc-welcome-era__gif--knockout" : "";
    return `<img class="zc-welcome-era__gif${extra}" src="${gif.src}" alt="" draggable="false" data-gif="${i}">`;
  }).join("");

  const ERA_HTML =
    '<div class="zc-welcome-era" aria-hidden="true">' +
    '<div class="zc-welcome-era__stars"></div>' +
    '<div class="zc-welcome-era__warp" aria-hidden="true">' +
    '<div class="zc-welcome-era__warp-field"></div>' +
    '<div class="zc-welcome-era__warp-field zc-welcome-era__warp-field--b"></div>' +
    '<div class="zc-welcome-era__warp-flash"></div>' +
    "</div>" +
    '<div class="zc-welcome-era__bezel">' +
    '<div class="zc-welcome-era__glass">' +
    '<div class="zc-welcome-era__hazard"></div>' +
    '<div class="zc-welcome-era__marquee">' +
    '<div class="zc-welcome-era__marquee-track">' +
    "<span>*** UNDER CONSTRUCTION ***&nbsp;&nbsp;LAST UPDATED 1998 ***&nbsp;&nbsp;BEST VIEWED IN NETSCAPE 3.0 ***&nbsp;&nbsp;</span>" +
    "<span>*** UNDER CONSTRUCTION ***&nbsp;&nbsp;LAST UPDATED 1998 ***&nbsp;&nbsp;BEST VIEWED IN NETSCAPE 3.0 ***&nbsp;&nbsp;</span>" +
    "</div>" +
    "</div>" +
    '<div class="zc-welcome-era__body">' +
    '<p class="zc-welcome-era__title">ZIGGY\'S CYCLE<br>ONLINE</p>' +
    '<p class="zc-welcome-era__blink">*** UNDER CONSTRUCTION ***</p>' +
    `<div class="zc-welcome-era__gifs">${gifHtml}</div>` +
    '<p class="zc-welcome-era__note">Est. 1985 &nbsp;·&nbsp; Last updated 1998</p>' +
    "</div>" +
    '<div class="zc-welcome-era__footer">' +
    '<p class="zc-welcome-era__meta">visitors: <span class="zc-welcome-era__counter" aria-hidden="true">' +
    "<b>0</b><b>0</b><b>0</b><b>0</b><b>4</b><b>7</b>" +
    "</span> &nbsp;·&nbsp; 1998</p>" +
    '<div class="zc-welcome-era__badges">' +
    '<div class="zc-welcome-era__badge zc-welcome-era__badge--ns"><span>Best viewed</span><b>Netscape 3.0</b><span>800×600</span></div>' +
    '<div class="zc-welcome-era__badge zc-welcome-era__badge--ie"><span>Get</span><b>Internet Explorer</b></div>' +
    '<div class="zc-welcome-era__badge zc-welcome-era__badge--y2k"><span>Y2K</span><b>Compliant</b></div>' +
    "</div>" +
    "</div>" +
    '<div class="zc-welcome-era__hazard"></div>' +
    '<div class="zc-welcome-era__scan"></div>' +
    '<div class="zc-welcome-era__roll"></div>' +
    '<div class="zc-welcome-era__vignette"></div>' +
    '<div class="zc-welcome-era__flicker"></div>' +
    "</div>" +
    "</div>" +
    '<div class="zc-welcome-era__dialog">' +
    '<div class="zc-welcome-era__dialog-bar">Leaving 1998</div>' +
    `<div class="zc-welcome-era__peek">${CAT_PEEK}</div>` +
    "<p>A website from this century is available.</p>" +
    '<div class="zc-welcome-era__bar"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>' +
    "</div>" +
    '<div class="zc-welcome-era__clock" aria-hidden="true">' +
    '<p class="zc-welcome-era__year">1998</p>' +
    '<p class="zc-welcome-era__year-cap">the 90s</p>' +
    "</div>" +
    "</div>";

  function reduceMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function state(slide) {
    if (!slide._zcWelcome) slide._zcWelcome = { timers: [], raf: 0, release: null, sparkBound: false };
    return slide._zcWelcome;
  }

  function clearPlay(slide) {
    const s = state(slide);
    s.timers.forEach(clearTimeout);
    s.timers = [];
    if (s.raf) cancelAnimationFrame(s.raf);
    s.raf = 0;
    if (s.release) {
      s.release();
      s.release = null;
    }
  }

  function later(slide, fn, ms) {
    state(slide).timers.push(setTimeout(fn, ms));
  }

  function findSlideshow(slide) {
    return (
      slide.closest("slideshow-component") ||
      slide.closest("slideshow-container") ||
      slide.closest("slideshow") ||
      slide.parentElement
    );
  }

  function holdSlideshow(slide) {
    const host = findSlideshow(slide);
    if (!host || typeof host.pause !== "function") return () => {};
    host.pause();
    return () => {
      if (typeof host.play === "function") host.play();
    };
  }

  function yearCaption(year) {
    if (year < 2000) return "the 90s";
    if (year < 2020) return "leaving the 90s";
    return "the present";
  }

  function tickYears(slide) {
    const el = slide.querySelector(".zc-welcome-era__year");
    const cap = slide.querySelector(".zc-welcome-era__year-cap");
    if (!el) return;
    const s = state(slide);
    const from = 1998;
    const to = 2026;
    const start = performance.now();
    const dur = 3400;
    let last = from - 1;
    const paint = (year) => {
      el.textContent = String(year);
      if (cap) cap.textContent = yearCaption(year);
      el.classList.remove("zc-welcome-era__year--tick");
      void el.offsetWidth;
      el.classList.add("zc-welcome-era__year--tick");
    };
    const step = (now) => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      const t = Math.min(1, (now - start) / dur);
      const year = from + Math.round((to - from) * t);
      if (year !== last) {
        last = year;
        paint(year);
      }
      if (t < 1) s.raf = requestAnimationFrame(step);
    };
    paint(from);
    last = from;
    s.raf = requestAnimationFrame(step);
  }

  function tickCounter(slide) {
    const digits = [...slide.querySelectorAll(".zc-welcome-era__counter b")];
    if (!digits.length) return;
    const s = state(slide);
    const from = 47;
    const to = 61;
    const start = performance.now();
    const dur = 2800;
    const paint = (n) => {
      const str = String(n).padStart(digits.length, "0");
      digits.forEach((el, i) => {
        el.textContent = str[i] || "0";
      });
    };
    const step = (now) => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      const t = Math.min(1, (now - start) / dur);
      paint(Math.round(from + (to - from) * t));
      if (t < 1) s.raf = requestAnimationFrame(step);
    };
    s.raf = requestAnimationFrame(step);
  }

  function bindSparkles(slide) {
    const s = state(slide);
    if (s.sparkBound || reduceMotion()) return;
    const layer = slide.querySelector(".zc-welcome-era");
    if (!layer) return;
    s.sparkBound = true;
    let last = 0;
    const colors = ["", "zc-welcome-era__spark--gold", "zc-welcome-era__spark--cyan", "zc-welcome-era__spark--pink"];
    layer.addEventListener("mousemove", (event) => {
      if (slide.dataset.zcWelcome === "live") return;
      const now = performance.now();
      if (now - last < 28) return;
      last = now;
      const rect = layer.getBoundingClientRect();
      const spark = document.createElement("span");
      spark.className = `zc-welcome-era__spark ${colors[Math.floor(Math.random() * colors.length)] || ""}`;
      const size = 5 + Math.random() * 8;
      spark.style.width = `${size}px`;
      spark.style.height = `${size}px`;
      spark.style.left = `${event.clientX - rect.left}px`;
      spark.style.top = `${event.clientY - rect.top}px`;
      spark.style.setProperty("--rot", `${Math.random() * 360}deg`);
      layer.appendChild(spark);
      setTimeout(() => spark.remove(), 700);
    });
  }

  function setPhase(slide, phase) {
    slide.dataset.zcWelcome = phase;
  }

  function reset(slide) {
    clearPlay(slide);
    slide.classList.remove("zc-welcome-live", "zc-welcome-era-on");
    delete slide.dataset.zcWelcome;
  }

  function playModern(slide) {
    slide.classList.remove("zc-welcome-live");
    void slide.offsetWidth;
    slide.classList.add("zc-welcome-live");
  }

  function play(slide) {
    clearPlay(slide);
    slide.classList.remove("zc-welcome-live", "zc-welcome-era-on");

    if (slide.getAttribute("aria-hidden") === "true") return;

    if (reduceMotion()) {
      setPhase(slide, "live");
      playModern(slide);
      return;
    }

    setPhase(slide, "boot");

    if (!slide.querySelector(".zc-welcome-era")) {
      slide.insertAdjacentHTML("beforeend", ERA_HTML);
    }

    bindSparkles(slide);
    slide.classList.add("zc-welcome-era-on");
    state(slide).release = holdSlideshow(slide);

    later(slide, () => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      setPhase(slide, "old");
      tickCounter(slide);
    }, BOOT_MS);

    later(slide, () => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      setPhase(slide, "update");
    }, UPDATE_MS);

    later(slide, () => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      if (state(slide).raf) cancelAnimationFrame(state(slide).raf);
      setPhase(slide, "years");
      tickYears(slide);
    }, YEARS_MS);

    later(slide, () => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      slide.classList.remove("zc-welcome-era-on");
      setPhase(slide, "live");
      playModern(slide);
    }, LIVE_MS);

    later(slide, () => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      const host = findSlideshow(slide);
      state(slide).release = null;
      if (host && typeof host.next === "function") host.next();
      if (host && typeof host.play === "function") host.play();
    }, HOLD_MS);
  }

  function bindWelcome(slide) {
    if (slide.dataset.zcWelcomeBound === "1") return;
    slide.dataset.zcWelcomeBound = "1";
    slide.querySelector(".zc-welcome-fx")?.remove();

    const watch = () => {
      if (slide.getAttribute("aria-hidden") === "true") reset(slide);
      else play(slide);
    };

    new MutationObserver(watch).observe(slide, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
    watch();
  }

  function preferFirstWelcome() {
    const slide = document.querySelector(WELCOME_SEL);
    if (!slide) return;
    const host = findSlideshow(slide);
    const first = host?.querySelector("slideshow-slide");
    if (!host || first !== slide) return;
    if (slide.getAttribute("aria-hidden") === "true" && typeof host.select === "function") {
      host.select(slide);
    }
  }

  function scan() {
    preferFirstWelcome();
    document.querySelectorAll(WELCOME_SEL).forEach(bindWelcome);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  document.addEventListener("shopify:section:load", scan);
  document.addEventListener("shopify:section:reorder", scan);
  document.addEventListener("shopify:block:select", (event) => {
    const slide = event.target?.closest?.("slideshow-slide");
    if (slide?.querySelector('[class*="text_welcome_hello"]')) play(slide);
  });
})();
